import List from "app/stores/list"
import { action } from 'mobx'
import config from 'app/config'
import request from 'app/vendor/request'

export default class Store {

  @action getDownloadLinks = (dataIds) => {
    return request.post(`${config.backend}/preview/datas/downloads`)
      .send(dataIds)
      .checkToken()
      .commonDispose()
  }

  @action exportDataStep = (groupId, templateId) => {
    return request.post(`${config.backend}/accounts/statistic?${this.list.queryString}`)
      .query(this.list.processQueryMap)
      .checkToken()
      .commonDispose()
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "accounts/statistic")
    return store
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/preview/data_statistics.js